import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment, ActorType } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import logError from 'src/utils/logError';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment;
}

const ActivityLogTaskFlagResolvedChangeRequested: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;

  // eslint-disable-next-line no-underscore-dangle
  if (details?.__typename !== 'ActivityLogFlagDetails') {
    logError('ActivityLogTaskFlagResolvedChangeRequested: details is not ActivityLogFlagDetails');
    return null;
  }

  const { flagContent } = details;

  const flagContentShort = flagContent.length > 30 ? `${flagContent.slice(0, 30)}...` : flagContent;

  const actionLabelInfo = (() => {
    if (ActorType.Candidate === activityLog.activityActorType) {
      if (flagContent) {
        return {
          key: 'hiring-dashboard-candidates:candidates.activityLog.canceledChangeRequestWithContent',
          fallback: `canceled their change request: ${flagContentShort}`,
        };
      }

      return {
        key: 'hiring-dashboard-candidates:candidates.activityLog.canceledChangeRequest',
        fallback: 'canceled their change request',
      };
    }

    if (flagContent) {
      return {
        key: 'hiring-dashboard-candidates:candidates.activityLog.resolvedFlagWithContent',
        fallback: `resolved a flag: ${flagContentShort}`,
      };
    }

    return {
      key: 'hiring-dashboard-candidates:candidates.activityLog.resolvedFlag',
      fallback: 'resolved a flag',
    };
  })();

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabel={actionLabelInfo.fallback}
      actionLabelKey={actionLabelInfo.key}
      actionLabelValues={{ flagContent: flagContentShort }}
      actionLabelTooltip={flagContent}
    />
  );
};

ActivityLogTaskFlagResolvedChangeRequested.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskFlagResolvedChangeRequested_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogFlagDetails {
          flagContent
          __typename
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskFlagResolvedChangeRequested;
